import { Layout } from 'antd';
import NavBar from './components/navBar/NavBar';
import './index.css';

const { Content } = Layout;

export const DefaultLayout = props => {
  return (
    <Layout>
      <NavBar />
      <Content className='mainContentBox'>{props.children}</Content>
    </Layout>
  );
};
